// extracted by mini-css-extract-plugin
module.exports = {"default":"SuperSelect_default__20UaA"};